import { render } from "./DesignReadinessStrip.vue?vue&type=template&id=607e035c&scoped=true"
import script from "./DesignReadinessStrip.vue?vue&type=script&lang=js"
export * from "./DesignReadinessStrip.vue?vue&type=script&lang=js"

import "./DesignReadinessStrip.vue?vue&type=style&index=0&id=607e035c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e035c"]])

export default __exports__